export type { SearchFilterStructureRo as WlasFilterOptions } from '@/types';
export { useGetSearchFilters as useGetWlasFilterOptions } from './useGetSearchFilters';
